import { render, staticRenderFns } from "./MerchantStatements.vue?vue&type=template&id=523d2c3e"
import script from "./MerchantStatements.vue?vue&type=script&lang=js"
export * from "./MerchantStatements.vue?vue&type=script&lang=js"
import style0 from "./MerchantStatements.vue?vue&type=style&index=0&id=523d2c3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports